import routes from '@/Router/routes.constants'

export const summaryInputsResetPaths = [
  routes.productSelectionPage,
  routes.deliveryMethodsPage,
  routes.refundSelectionPage,
  routes.summaryPage,
]
